import { apiClient } from '@/api/client'
import type { GradeRecordingRequest, GradeRecordingResponse } from '@/api/type'

export const gradeRecording = async (request: GradeRecordingRequest): Promise<GradeRecordingResponse> => {
  const formData = new FormData()

  // Convert webm to wav (placeholder - actual conversion would be needed)
  formData.append('audio', request.audio, 'recording.webm')
  formData.append('reference_text', request.referenceText)
  formData.append('use_ai', request.useAI.toString())

  const res = await apiClient.post(`/grade-recording`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return res.data
}

export const gradeRecordingStream = async (
  request: GradeRecordingRequest,
  onProgress: (progress: number) => void,
): Promise<GradeRecordingResponse> => {
  const formData = new FormData()
  formData.append('audio', request.audio, 'recording.webm')
  formData.append('reference_text', request.referenceText)
  formData.append('use_ai', request.useAI.toString())

  return new Promise((resolve, reject) => {
    let hasResult = false
    let processedLength = 0

    // タイムアウト設定（5分）
    const timeoutId = setTimeout(
      () => {
        if (!hasResult) {
          reject(new Error('採点処理がタイムアウトしました（5分経過）'))
        }
      },
      5 * 60 * 1000,
    )

    apiClient
      .post(`/grade-recording-stream`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        responseType: 'text',
        timeout: 5 * 60 * 1000,
        onDownloadProgress: (progressEvent) => {
          const responseText = progressEvent.event?.target?.response as string | undefined
          if (!responseText) return

          // 新しく受信した部分のみを処理
          const newData = responseText.slice(processedLength)
          processedLength = responseText.length

          // SSE形式のデータを解析
          const lines = newData.split('\n')
          for (const line of lines) {
            if (line.startsWith('data: ')) {
              try {
                const jsonStr = line.slice(6)
                const data = JSON.parse(jsonStr)

                if (data.error) {
                  clearTimeout(timeoutId)
                  hasResult = true
                  reject(new Error(data.error))
                  return
                } else if (data.result) {
                  clearTimeout(timeoutId)
                  hasResult = true
                  resolve(data.result)
                  return
                } else if (data.progress !== undefined) {
                  onProgress(data.progress)
                }
              } catch {
                // パースエラーは無視して続行
              }
            }
          }
        },
      })
      .then(() => {
        clearTimeout(timeoutId)
        if (!hasResult) {
          reject(new Error('サーバーから結果が返されませんでした。処理が途中で中断された可能性があります。'))
        }
      })
      .catch((err) => {
        clearTimeout(timeoutId)
        if (!hasResult) {
          reject(err)
        }
      })
  })
}
